import React from 'react';
import '../../../CSS/hero_section.scss';
import HeroSectionContent from './HeroSectionContent';
const HeroSection = ({data})=> {
return (
    <div className="hero-section">
        <div className="hero-image">
        <div className="hero-content">
            {data && <HeroSectionContent data={data}/>}
        </div>
            {/* <img src={data.image}/> */}
            <div className="hero-image-overlay">
                <div className="icon">
                    <div className="sub-icon"></div>
                </div>
            </div>
        </div>
    </div>
);
}

export default HeroSection;